export default __webpack_public_path__ + "static/media/blog_2_2.4482aa2b.jpg";